import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Layout from './components/layout/Layout';
import Landing from './components/pages/Landing';
import About from './components/pages/About';
import Product from './components/pages/Product';
import Features from './components/pages/Features';
import Pricing from './components/pages/Pricing';
import Contact from './components/pages/Contact';
import OurDrive from './components/pages/OurDrive';
import LevelUp from './components/pages/LevelUp';
import Investors from './components/pages/Investors';
import FAQ from './components/pages/FAQ';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import Dashboard from './components/pages/Dashboard';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Landing />} />
            <Route path="about" element={<About />} />
            <Route path="our-drive" element={<OurDrive />} />
            <Route path="level-up" element={<LevelUp />} />
            <Route path="investors" element={<Investors />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="product" element={<Product />} />
            <Route path="features" element={<Features />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="dashboard" element={<Dashboard />} />
          </Route>
        </Routes>
        <Analytics />
      </Router>
    </AuthProvider>
  );
}

export default App;
